module.exports = __webpack_public_path__ + "static/media/liquidez.9242e535.png";